export default "{\n    \"emptyStateLabel\": \"No se encontraron resultados\"\n}\n"